/* DW-START — Dazzle Wears Cart Drawer JS v26 (native-style discount code UI: apply/remove/display) */
(function() {
  'use strict';

  var DW_NO_CUSTOM  = ['10558871765295','10285872382255','10627586326831'];
  var DW_EXCLUDED   = ['8285241934127','10369232077103'];
  var DW_INSURANCE_PIDS = ['8285241934127','10369232077103'];

  // Popup upload state
  var _popUploading = false;
  var _popUploadedUrl = null;
  var _popUploadError = null;

  // Popup birthstone mix state
  var _popBsmSelections = {};
  var BSM_MONTHS = [
    {name:'January',   color:'#8B0A0C'},
    {name:'February',  color:'#6B4463'},
    {name:'March',     color:'#8DADC3'},
    {name:'April',     color:'#E8E6E0'},
    {name:'May',       color:'#477044'},
    {name:'June',      color:'#FBE0C3'},
    {name:'July',      color:'#7E0631'},
    {name:'August',    color:'#939B2B'},
    {name:'September', color:'#062D4C'},
    {name:'October',   color:'#8C9F5B'},
    {name:'November',  color:'#95791E'},
    {name:'December',  color:'#10497F'}
  ];
  function bsmMonthFor(name){for(var i=0;i<BSM_MONTHS.length;i++)if(BSM_MONTHS[i].name===name)return BSM_MONTHS[i];return null;}

  function bsmPopCount(){
    var varSel=el('dw-popup-variant');
    if(varSel&&varSel.tagName==='SELECT'){
      var opt=varSel.options[varSel.selectedIndex];
      var t=opt?(opt.dataset.title||opt.textContent):'';
      var v=parseInt(t,10);
      if(v>=1&&v<=8)return v;
    } else if(varSel){
      return 1;
    }
    return 1;
  }

  function bsmPopCloseAll(container){
    var open=container.querySelectorAll('.dw-bsm-slot.dw-bsm-open');
    for(var i=0;i<open.length;i++)open[i].classList.remove('dw-bsm-open');
  }

  function bsmPopBuildSlot(index,selectedMonth){
    var slot=document.createElement('div');slot.className='dw-bsm-slot';slot.dataset.index=index;
    var head=document.createElement('div');head.className='dw-bsm-slot-head';
    var num=document.createElement('div');num.className='dw-bsm-num';num.textContent=index;
    var swatch=document.createElement('div');swatch.className='dw-bsm-swatch';
    var monthObj=bsmMonthFor(selectedMonth);
    swatch.style.setProperty('background-color',monthObj?monthObj.color:'#f4f0ea','important');
    if(!monthObj)swatch.style.border='1px dashed #ccc';
    var name=document.createElement('div');name.className='dw-bsm-name'+(selectedMonth?'':' dw-bsm-placeholder');name.textContent=selectedMonth||'Choose a birthstone…';
    var chev=document.createElement('div');chev.className='dw-bsm-chevron';chev.textContent='▾';
    head.appendChild(num);head.appendChild(swatch);head.appendChild(name);head.appendChild(chev);
    slot.appendChild(head);
    var picker=document.createElement('div');picker.className='dw-bsm-picker';
    BSM_MONTHS.forEach(function(m){
      var opt=document.createElement('div');opt.className='dw-bsm-month'+(m.name===selectedMonth?' dw-bsm-selected':'');
      var dot=document.createElement('div');dot.className='dw-bsm-dot';dot.style.setProperty('background-color',m.color,'important');
      var lbl=document.createElement('div');lbl.className='m';lbl.textContent=m.name.slice(0,3);
      opt.appendChild(dot);opt.appendChild(lbl);
      opt.addEventListener('click',(function(monthName){
        return function(e){
          e.stopPropagation();
          _popBsmSelections[index]=monthName;
          var err=el('pop-bsm-err');if(err)err.style.display='none';
          bsmPopRenderSlots();
        };
      })(m.name));
      picker.appendChild(opt);
    });
    slot.appendChild(picker);
    head.addEventListener('click',function(){
      var wasOpen=slot.classList.contains('dw-bsm-open');
      var container=el('pop-bsm-slots');
      if(container)bsmPopCloseAll(container);
      if(!wasOpen)slot.classList.add('dw-bsm-open');
    });
    return slot;
  }

  function bsmPopRenderSlots(){
    var container=el('pop-bsm-slots');
    if(!container)return;
    var count=bsmPopCount();
    var kept={};
    for(var i=1;i<=count;i++){if(_popBsmSelections[i])kept[i]=_popBsmSelections[i];}
    _popBsmSelections=kept;
    container.innerHTML='';
    for(var j=1;j<=count;j++)container.appendChild(bsmPopBuildSlot(j,_popBsmSelections[j]));
  }

  function formatMoney(activeCents) {
    if (window.dwFmt) return window.dwFmt(activeCents);
    var fmt = window.dwMoneyFormat || '${{amount}}';
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(activeCents, fmt);
    var a = (activeCents/100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/g,a).replace(/\{\{\s*amount_no_decimals\s*\}\}/g,Math.round(activeCents/100));
  }

  function getCustom(pid, tags) {
    if (DW_NO_CUSTOM.includes(String(pid))) return {noCustom:true};
    var t = (tags||'').toLowerCase();
    return {
      noCustom:   false,
      upload:     t.includes('imageupload'),
      front:      t.includes('frontext'),
      back:       t.includes('backtext'),
      forher:     t.includes('forhertext'),
      forhim:     t.includes('forhimtext'),
      leftright:  t.includes('textleftright'),
      morse:      t.includes('morsecode'),
      birthstonemix: t.includes('birthstonemix')
    };
  }

  function esc(s){return s?String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'):''}
  function el(id){return document.getElementById(id)}
  async function fetchCart(){return(await fetch('/cart.js')).json()}
  async function changeItem(ln,qty){return(await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:ln,quantity:qty})})).json()}
  async function addItems(items){
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!r.ok){var e=await r.json();throw new Error(e.description||'Could not add item');}
    return r.json();
  }
  async function getRecs(pid,limit){
    try{var d=await(await fetch('/recommendations/products.json?product_id='+pid+'&limit='+(limit+2)+'&intent=related')).json();return(d.products||[]).filter(p=>!DW_EXCLUDED.includes(String(p.id))).slice(0,limit);}catch(e){return[];}
  }

  async function purgeOrphanInsurance() {
    var cart;
    try { cart = await fetchCart(); } catch(e) { return null; }
    if (!cart.items || cart.items.length === 0) return cart;
    var realItems = cart.items.filter(function(item) {
      return !DW_INSURANCE_PIDS.includes(String(item.product_id));
    });
    if (realItems.length === 0 && cart.items.length > 0) {
      await fetch('/cart/clear.js', {method:'POST',headers:{'Content-Type':'application/json'}}).catch(function(){});
      return {items:[], item_count:0, total_price:0};
    }
    return cart;
  }

  function openDrawer(){
    var d=el('dw-cart-drawer'),o=el('dw-cart-overlay');
    if(!d)return;
    d.classList.add('dw-open');
    if(o)o.classList.add('dw-open');
    document.body.style.overflow='hidden';
    purgeOrphanInsurance().then(function(cart){ renderCartFromData(cart); });
  }
  function closeDrawer(){var d=el('dw-cart-drawer'),o=el('dw-cart-overlay');if(!d)return;d.classList.remove('dw-open');if(o)o.classList.remove('dw-open');document.body.style.overflow='';}

  function updateBadge(n){
    document.querySelectorAll('[data-dw-cart-count]').forEach(function(e){e.textContent=n;e.setAttribute('data-count',n);});
    var dc=el('dw-cart-count');if(dc)dc.textContent=n;
    var b=document.querySelector('.cart-count-bubble');
    if(b){
      if(n>0){
        var s=b.querySelector('span:not(.visually-hidden)');
        if(s)s.textContent=n<100?n:'';
        b.style.display='';
      } else {
        b.style.display='none';
      }
    }
  }

  async function renderCart(){
    var cart = await purgeOrphanInsurance();
    if (cart) renderCartFromData(cart);
  }

  function renderProp(key, value) {
    if (key === 'Customer Photo') {
      return '<div class="dw-cart-item__props"><span style="font-weight:600">Uploaded Photo:</span> <a href="'+esc(value)+'" target="_blank" rel="noopener" class="dw-cart-item__photo-link">View</a></div>';
    }
    return '<div class="dw-cart-item__props"><span style="font-weight:600">'+esc(key)+':</span> '+esc(value)+'</div>';
  }

  function renderCartFromData(cart){
    if (!cart) return;
    var realItems=cart.items.filter(function(item){return !DW_INSURANCE_PIDS.includes(String(item.product_id));});
    var badgeCount=realItems.reduce(function(s,i){return s+i.quantity;},0);
    updateBadge(badgeCount);
    var sub=el('dw-cart-subtotal-amount');
    if(sub)sub.textContent=formatMoney(cart.total_price);
    if(realItems.length===0){showEmpty();return;}
    showFilled();
    var list=el('dw-cart-items');
    if(list){
      list.innerHTML=cart.items.map(function(item,idx){
        var ln=idx+1;
        var props='';
        if(item.properties)Object.entries(item.properties).forEach(([k,v])=>{if(v&&!k.startsWith('_'))props+=renderProp(k,v);});
        var vt=(item.variant_title&&item.variant_title!=='Default Title')?'<div class="dw-cart-item__variant">'+esc(item.variant_title)+'</div>':'';
        return `<div class="dw-cart-item" data-line="${ln}"><img class="dw-cart-item__img" src="${item.image||''}" alt="${esc(item.product_title)}" loading="lazy"><div class="dw-cart-item__body"><div class="dw-cart-item__name">${esc(item.product_title)}</div>${vt}${props}<div class="dw-cart-item__footer"><div class="dw-cart-item__qty"><button class="dw-cart-item__qty-btn" data-action="dec" data-line="${ln}">&#8722;</button><span class="dw-cart-item__qty-val">${item.quantity}</span><button class="dw-cart-item__qty-btn" data-action="inc" data-line="${ln}">+</button></div><span class="dw-cart-item__price">${formatMoney(item.line_price)}</span><button class="dw-cart-item__remove" data-line="${ln}">&times;</button></div></div></div>`;
      }).join('');
      list.querySelectorAll('.dw-cart-item__qty-btn').forEach(btn=>{btn.addEventListener('click',()=>{var ln=parseInt(btn.dataset.line),act=btn.dataset.action,qv=btn.closest('.dw-cart-item__qty').querySelector('.dw-cart-item__qty-val'),qty=parseInt(qv.textContent);if(act==='inc')qty++;else qty=Math.max(0,qty-1);changeItem(ln,qty).then(renderCart);});});
      list.querySelectorAll('.dw-cart-item__remove').forEach(btn=>{btn.addEventListener('click',()=>changeItem(parseInt(btn.dataset.line),0).then(renderCart));});
    }
    var ul=el('dw-cart-upsell-list');if(ul&&realItems.length)loadUpsells(realItems[0].product_id,cart.items.map(i=>i.variant_id),cart.items.map(i=>String(i.product_id)));
    renderDiscountState(cart);
  }

  function renderDiscountState(cart){
    var applied=el('dw-cart-discount-applied'),toggle=el('dw-cart-discount-toggle'),form=el('dw-cart-discount-form');
    if(!applied||!toggle||!form)return;
    var apps=cart.cart_level_discount_applications||[];
    if(apps.length){
      var app=apps[0];
      var codeEl=el('dw-cart-discount-code'),amtEl=el('dw-cart-discount-amount');
      if(codeEl)codeEl.textContent=app.title||'';
      if(amtEl)amtEl.textContent='-'+formatMoney(cart.total_discount||0);
      applied.style.display='flex';
      toggle.style.display='none';
      form.style.display='none';
    } else {
      applied.style.display='none';
      toggle.style.display='block';
    }
  }

  async function applyDiscount(code){
    var errEl=el('dw-cart-discount-error');
    if(errEl)errEl.style.display='none';
    try{
      var r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:code})});
      var cart=await r.json();
      renderCartFromData(cart);
      var apps=cart.cart_level_discount_applications||[];
      if(!apps.length&&errEl){errEl.style.display='block';}
    }catch(e){
      if(errEl)errEl.style.display='block';
    }
  }

  async function removeDiscount(){
    try{
      var r=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:''})});
      var cart=await r.json();
      renderCartFromData(cart);
    }catch(e){}
  }

  function showFilled(){
    var f=el('dw-cart-filled'),e=el('dw-cart-empty');
    if(e)e.style.display='none';
    if(f){f.style.display='flex';f.style.flex='1';f.style.flexDirection='column';f.style.minHeight='0';f.style.overflow='hidden';}
  }
  function showEmpty(){
    var f=el('dw-cart-filled'),e=el('dw-cart-empty');
    if(f)f.style.display='none';
    if(e)e.style.display='flex';
    var us=el('dw-cart-upsells');if(us)us.style.display='none';
  }

  async function loadUpsells(pid,cartVids,cartPids){
    var ul=el('dw-cart-upsell-list'),us=el('dw-cart-upsells');if(!ul)return;
    ul.innerHTML='<div style="font-size:11px;color:#bbb;padding:8px 0">Loading&hellip;</div>';
    var recs=await getRecs(pid,6);
    var f=recs.filter(p=>!cartPids.includes(String(p.id))&&!p.variants.some(v=>cartVids.includes(v.id))).slice(0,4);
    if(!f.length){ul.innerHTML='';if(us)us.style.display='none';return;}
    if(us)us.style.display='block';
    ul.innerHTML=f.map(p=>{
      var img=(p.featured_image&&typeof p.featured_image==='string')?p.featured_image:(p.images&&p.images[0]?p.images[0].src:'');
      return `<div class="dw-cart-upsell" data-pid="${p.id}" data-handle="${esc(p.handle)}" data-tags="${esc((p.tags||[]).join(','))}" data-price-min="${p.price_min}"><img class="dw-cart-upsell__img" src="${img}" alt="${esc(p.title)}" loading="lazy"><div class="dw-cart-upsell__body"><div class="dw-cart-upsell__name">${esc(p.title)}</div><div class="dw-cart-upsell__price">${formatMoney(p.price_min)}</div></div><button class="dw-cart-upsell__btn">Add</button></div>`;
    }).join('');
    ul.querySelectorAll('.dw-cart-upsell__btn').forEach(btn=>{btn.addEventListener('click',()=>{
      var card=btn.closest('.dw-cart-upsell');
      showFPPopup(card.dataset.handle,card.dataset.pid||0,card.dataset.tags||'',parseInt(card.dataset.priceMin||'0'));
    });});
  }

  function showFPPopup(handle, pid, tags, priceMinCents) {
    fetch('/products/'+handle+'.js')
      .then(r=>r.json())
      .then(function(p){
        var custom=getCustom(p.id,(p.tags||[]).join(','));
        var variants=p.variants||[];
        if(!variants.length)return;
        var varImgMap = {};
        if (p.images && p.images.length) {
          p.images.forEach(function(img) {
            if (img.variant_ids && img.variant_ids.length) {
              img.variant_ids.forEach(function(vid) {
                if (!varImgMap[vid]) varImgMap[vid] = img.src;
              });
            }
          });
        }
        function variantImg(v) {
          return varImgMap[v.id] || (v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0] ? p.images[0].src : '');
        }
        buildAndShowPopup({pid:p.id,handle:p.handle,title:p.title,img:variantImg(variants[0]),variants:variants,variantImg:variantImg,custom:custom});
      })
      .catch(function(){});
  }

  function uploadPhotoXHR(file, progressEl, labelEl) {
    return new Promise(function(resolve, reject) {
      var fd = new FormData();
      fd.append('file', file, file.name);
      var xhr = new XMLHttpRequest();
      xhr.open('POST', window.dwPhotoConnectorUrl || 'https://dw-photo-connector.charlesudeh4real.workers.dev/');
      xhr.upload.onprogress = function(e) {
        if (e.lengthComputable && progressEl) {
          var pct = Math.round((e.loaded / e.total) * 90);
          progressEl.style.width = pct + '%';
          if (labelEl) labelEl.textContent = 'Uploading… ' + pct + '%';
        }
      };
      xhr.onload = function() {
        try {
          var data = JSON.parse(xhr.responseText);
          if (data && data.url) {
            if (progressEl) { progressEl.style.width = '100%'; progressEl.style.background = '#4caf50'; }
            if (labelEl) labelEl.textContent = 'Photo uploaded ✓';
            resolve(data.url);
          } else {
            reject(new Error((data && data.error) || 'Upload failed'));
          }
        } catch(e) { reject(new Error('Upload failed')); }
      };
      xhr.onerror = function() { reject(new Error('Network error')); };
      xhr.send(fd);
    });
  }

  function buildAndShowPopup(data){
    // Reset upload state for each popup open
    _popUploading = false;
    _popUploadedUrl = null;
    _popUploadError = null;
    _popBsmSelections = {};

    var ovId='dw-custpop-overlay';
    var ov=el(ovId);
    if(!ov){ov=document.createElement('div');ov.id=ovId;ov.className='dw-fp-popup-overlay';document.body.appendChild(ov);ov.addEventListener('click',e=>{if(e.target===ov)closePopup();});}
    var variants=data.variants||[],firstV=variants[0]||{};
    var variantImg=data.variantImg||function(){return data.img||'';};
    var variantHtml='';
    if(variants.length>1){
      variantHtml='<div class="dw-popup-field"><label class="dw-popup-label">Option</label><select id="dw-popup-variant" class="dw-popup-select">'+variants.map(v=>'<option value="'+v.id+'" data-img="'+esc(variantImg(v))+'" data-price="'+v.price+'" data-title="'+esc(v.title)+'">'+esc(v.title)+(v.available===false?' — Sold Out':'')+'</option>').join('')+'</select></div>';
    }else if(variants.length===1){
      variantHtml='<input type="hidden" id="dw-popup-variant" value="'+firstV.id+'">';
    }
    var customHtml=buildCustomFields(data.custom,'pop');
    var qtyHtml='<div class="dw-popup-field dw-popup-qty-row"><label class="dw-popup-label">Quantity</label><div class="dw-popup-qty"><button type="button" class="dw-popup-qty-btn" id="dw-popup-qty-dec">&#8722;</button><span class="dw-popup-qty-val" id="dw-popup-qty-val">1</span><button type="button" class="dw-popup-qty-btn" id="dw-popup-qty-inc">+</button></div></div>';
    var insHtml='<div class="dw-popup-ins" id="dw-popup-ins"><div class="dw-popup-ins__row"><div class="dw-popup-ins__check dw-popup-ins__check--on" id="dw-popup-ins-check" role="checkbox" aria-checked="true" tabindex="0"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg></div><div class="dw-popup-ins__body"><div class="dw-popup-ins__title">Insure my order <span class="dw-popup-ins__price" id="dw-popup-ins-price">+ $4.95</span></div><div class="dw-popup-ins__desc">Covers loss, theft &amp; damage in transit. Fast replacement guaranteed.</div></div></div></div>';
    var initPrice=firstV.price?formatMoney(parseInt(firstV.price)):'';
    ov.innerHTML='<div class="dw-fp-popup" role="dialog" id="dw-custpop">'
      +'<div class="dw-fp-popup__header">'
        +(data.img?'<img class="dw-fp-popup__img" id="dw-popup-hero-img" src="'+esc(data.img)+'" alt="'+esc(data.title)+'">':'')
        +'<div class="dw-fp-popup__meta">'
          +'<div class="dw-fp-popup__name">'+esc(data.title.replace(/\s+\u2014.*/,'').trim())+'</div>'
          +(initPrice?'<div class="dw-fp-popup__price" id="dw-popup-price-label">'+initPrice+'</div>':'')
        +'</div>'
        +'<button class="dw-fp-popup__close" id="dw-custpop-close">&times;</button>'
      +'</div>'
      +'<div class="dw-fp-popup__body" id="dw-custpop-body">'+variantHtml+customHtml+qtyHtml+insHtml+'</div>'
      +'<div class="dw-fp-popup__footer"><button class="dw-fp-popup__atc" id="dw-custpop-atc">Add to Cart</button></div>'
    +'</div>';
    el('dw-custpop-close').addEventListener('click',closePopup);
    var varSel=el('dw-popup-variant'),heroImg=el('dw-popup-hero-img'),priceLbl=el('dw-popup-price-label');
    if(varSel&&varSel.tagName==='SELECT'){
      varSel.addEventListener('change',function(){
        var opt=varSel.options[varSel.selectedIndex];
        if(priceLbl&&opt&&opt.dataset.price) priceLbl.textContent=formatMoney(parseInt(opt.dataset.price));
        if(heroImg&&opt&&opt.dataset.img&&opt.dataset.img.length>4){
          heroImg.style.opacity='0';
          setTimeout(function(){heroImg.src=opt.dataset.img;heroImg.style.opacity='1';},150);
        }
        if(data.custom&&data.custom.birthstonemix)bsmPopRenderSlots();
      });
    }
    if(data.custom&&data.custom.birthstonemix)bsmPopRenderSlots();
    var qtyVal=el('dw-popup-qty-val'),qtyDec=el('dw-popup-qty-dec'),qtyInc=el('dw-popup-qty-inc');
    if(qtyDec&&qtyInc&&qtyVal){qtyDec.addEventListener('click',function(){var q=parseInt(qtyVal.textContent);if(q>1)qtyVal.textContent=q-1;});qtyInc.addEventListener('click',function(){var q=parseInt(qtyVal.textContent);qtyVal.textContent=q+1;});}
    var insChk=el('dw-popup-ins-check');
    if(insChk){
      insChk.addEventListener('click',function(){var on=insChk.getAttribute('aria-checked')==='true';insChk.setAttribute('aria-checked',String(!on));insChk.classList.toggle('dw-popup-ins__check--on',!on);});
      insChk.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();insChk.click();}});
    }
    fetch('/products/shipping-insurance.js').then(function(r){return r.json();}).then(function(p){
      var priceEl=el('dw-popup-ins-price');if(!priceEl)return;
      var v=p.variants&&p.variants[0];if(!v)return;
      priceEl.textContent='+ '+formatMoney(v.price);
    }).catch(function(){});
    // Wire upload if needed
    bindUploadZone('pop', ov, data.custom);
    if(heroImg)heroImg.style.transition='opacity .15s ease';
    var atc=el('dw-custpop-atc');
    atc.addEventListener('click',function(){
      var vid=varSel?parseInt(varSel.value):parseInt(firstV.id);
      var qty=qtyVal?parseInt(qtyVal.textContent)||1:1;
      var props=collectCustomProps(data.custom,'pop',ov);
      if(props===null)return;
      // If upload required and still in progress — poll until done
      if(data.custom&&data.custom.upload&&!data.custom.noCustom){
        if(_popUploading){
          atc.textContent='Uploading…';atc.disabled=true;
          var poll=setInterval(function(){
            if(!_popUploading){
              clearInterval(poll);
              if(_popUploadError){
                atc.textContent='Add to Cart';atc.disabled=false;
                var ue=ov.querySelector('#pop-uerr');if(ue){ue.textContent='★ Upload failed — please retry';ue.style.display='block';}
              } else {
                doAddToCart(vid,qty,props,atc);
              }
            }
          },200);
          return;
        }
        if(_popUploadError){
          var ue=ov.querySelector('#pop-uerr');if(ue){ue.textContent='★ Upload failed — please retry';ue.style.display='block';}return;
        }
        if(_popUploadedUrl) props['Customer Photo']=_popUploadedUrl;
      }
      atc.textContent='Adding…';atc.disabled=true;
      doAddToCart(vid,qty,props,atc);
    });
    ov.style.opacity='0';ov.style.visibility='visible';
    requestAnimationFrame(()=>{ov.style.transition='opacity .25s ease';ov.style.opacity='1';});
    document.body.style.overflow='hidden';
  }

  function doAddToCart(vid, qty, props, atcBtn) {
    var popInsCheck=el('dw-popup-ins-check');
    var popInsOn=!popInsCheck||popInsCheck.getAttribute('aria-checked')!=='false';
    var itemsToAdd=[{id:vid,quantity:qty,properties:props}];
    if(popInsOn&&window.dwInsuranceVariantId)itemsToAdd.push({id:window.dwInsuranceVariantId,quantity:1,properties:{'_linked_product':String(vid)}});
    addItems(itemsToAdd).then(function(){
      closePopup();
      openDrawer();
    }).catch(function(e){
      alert(e.message);
      if(atcBtn){atcBtn.textContent='Add to Cart';atcBtn.disabled=false;}
    });
  }

  function closePopup(){var ov=el('dw-custpop-overlay');if(!ov)return;ov.style.opacity='0';setTimeout(()=>{ov.style.visibility='hidden';},260);document.body.style.overflow='';}

  function buildCustomFields(c,pfx){
    if(!c||c.noCustom)return'';
    var h='';
    if(c.upload){
      h+='<div class="dw-customizer__block">'
        +'<div class="dw-customizer__label">Your Photo <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div>'
        +'<div class="dw-upload-zone" id="'+pfx+'-zone" tabindex="0" role="button">'
          +'<svg viewBox="0 0 24 24"><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.35 8.04A7.494 7.494 0 000 15.5C0 19.64 3.36 23 7.5 23h11C22.52 23 26 19.52 26 15.5c0-3.79-2.93-6.9-6.65-7.46zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>'
          +'<div class="dw-upload-zone__title">Upload your photo</div>'
          +'<div class="dw-upload-zone__sub">JPG, PNG, WEBP &middot; Max 10MB</div>'
          +'<input type="file" id="'+pfx+'-file" accept="image/*" style="display:none">'
        +'</div>'
        +'<div class="dw-upload-preview" id="'+pfx+'-prev">'
          +'<img class="dw-upload-preview__img" id="'+pfx+'-pimg" src="" alt="">'
          +'<span class="dw-upload-preview__name" id="'+pfx+'-pname"></span>'
          +'<button class="dw-upload-preview__remove" id="'+pfx+'-prem">&times;</button>'
        +'</div>'
        +'<div class="dw-upload-progress" id="'+pfx+'-prog" style="display:none;margin-top:8px">'
          +'<div style="height:4px;background:#ece8e1;border-radius:2px;overflow:hidden"><div id="'+pfx+'-prog-bar" style="height:4px;background:#c9a96e;border-radius:2px;width:0%;transition:width .2s"></div></div>'
          +'<div id="'+pfx+'-prog-lbl" style="font-size:10px;color:#888;margin-top:4px">Uploading…</div>'
        +'</div>'
        +'<div class="dw-upload-error" id="'+pfx+'-uerr">&#9733; Please upload your photo</div>'
      +'</div>';
    }
    if(c.front){h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Front Text Engraving <span class="dw-customizer__badge dw-customizer__badge--optional">Optional</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Pet name, date, or message</span><span class="dw-text-field__count" id="'+pfx+'-fc">0/20</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-ftxt" maxlength="20" placeholder="e.g. Forever in My Heart"><div class="dw-text-field__sub">Max 20 characters &middot; Leave blank to omit</div></div>';}
    if(c.back){h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Back Text Engraving <span class="dw-customizer__badge dw-customizer__badge--optional">Optional</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Back of pendant</span><span class="dw-text-field__count" id="'+pfx+'-bc">0/20</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-btxt" maxlength="20" placeholder="e.g. 2010–2024"><div class="dw-text-field__sub">Max 20 characters &middot; Leave blank to omit</div></div>';}
    if(c.forher){h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Front Text Engraving - For Her <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Name, date, or phrase</span><span class="dw-text-field__count" id="'+pfx+'-fhrc">0/20</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-fhrtxt" maxlength="20" placeholder="e.g. Sarah"><div class="dw-upload-error" id="'+pfx+'-fhrerr">&#9733; Please enter the engraving for her</div></div>';}
    if(c.forhim){h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Back Text Engraving - For Him <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Name, date, or phrase</span><span class="dw-text-field__count" id="'+pfx+'-fhmc">0/20</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-fhmtxt" maxlength="20" placeholder="e.g. James"><div class="dw-upload-error" id="'+pfx+'-fhmerr">&#9733; Please enter the engraving for him</div></div>';}
    if(c.leftright){
      h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Left Heart Engraving <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Name, initial, or date</span><span class="dw-text-field__count" id="'+pfx+'-lc">0/15</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-ltxt" maxlength="15" placeholder="e.g. Sarah"><div class="dw-upload-error" id="'+pfx+'-lerr">&#9733; Please enter left heart engraving</div></div>'
        +'<div class="dw-customizer__block"><div class="dw-customizer__label">Right Heart Engraving <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Name, initial, or date</span><span class="dw-text-field__count" id="'+pfx+'-rc">0/15</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-rtxt" maxlength="15" placeholder="e.g. James"><div class="dw-upload-error" id="'+pfx+'-rerr">&#9733; Please enter right heart engraving</div></div>';
    }
    if(c.morse){h+='<div class="dw-customizer__block"><div class="dw-customizer__label">Morse Code Customization <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-text-field__row"><span class="dw-text-field__hint">Word or phrase to encode in Morse</span><span class="dw-text-field__count" id="'+pfx+'-mc">0/30</span></div><input class="dw-text-field__input" type="text" id="'+pfx+'-mtxt" maxlength="30" placeholder="e.g. I Love You"><div class="dw-upload-error" id="'+pfx+'-merr">&#9733; Please enter your Morse code message</div></div>';}
    if(c.birthstonemix){h+='<div class="dw-customizer__block" id="'+pfx+'-bsm-block"><div class="dw-customizer__label">Choose Your Birthstones <span class="dw-customizer__badge dw-customizer__badge--required">Required</span></div><div class="dw-bsm-hint">Select a color for each birthstone position &middot; tap a row to choose</div><div class="dw-bsm-slots" id="'+pfx+'-bsm-slots"></div><div class="dw-upload-error" id="'+pfx+'-bsm-err">&#9733; Please choose a birthstone for every position before adding to cart</div></div>';}
    setTimeout(function(){
      function bc(a,b){var i=document.getElementById(a),c=document.getElementById(b);if(i&&c)i.addEventListener('input',function(){c.textContent=i.value.length+'/'+i.maxLength;});}
      bc(pfx+'-ftxt',pfx+'-fc');bc(pfx+'-btxt',pfx+'-bc');bc(pfx+'-fhrtxt',pfx+'-fhrc');bc(pfx+'-fhmtxt',pfx+'-fhmc');
      bc(pfx+'-ltxt',pfx+'-lc');bc(pfx+'-rtxt',pfx+'-rc');bc(pfx+'-mtxt',pfx+'-mc');
    },50);
    return h;
  }

  function bindUploadZone(pfx, wrap, custom) {
    var zone=wrap.querySelector('#'+pfx+'-zone');
    var file=wrap.querySelector('#'+pfx+'-file');
    var prev=wrap.querySelector('#'+pfx+'-prev');
    var rem=wrap.querySelector('#'+pfx+'-prem');
    var progWrap=wrap.querySelector('#'+pfx+'-prog');
    var progBar=wrap.querySelector('#'+pfx+'-prog-bar');
    var progLbl=wrap.querySelector('#'+pfx+'-prog-lbl');
    var ue=wrap.querySelector('#'+pfx+'-uerr');
    if(!zone||!file)return;
    zone.onclick=function(){file.click();};
    zone.onkeydown=function(e){if(e.key==='Enter'||e.key===' ')file.click();};
    file.onchange=function(){
      var f=file.files[0];if(!f)return;
      // Preview
      var r=new FileReader();
      r.onload=function(ev){var pi=wrap.querySelector('#'+pfx+'-pimg');if(pi)pi.src=ev.target.result;};
      r.readAsDataURL(f);
      var pn=wrap.querySelector('#'+pfx+'-pname');if(pn)pn.textContent=f.name+'✓';
      zone.style.display='none';
      if(prev)prev.style.display='flex';
      if(ue)ue.style.display='none';
      // Show progress bar and start upload immediately
      if(progWrap){progWrap.style.display='block';}
      if(progBar){progBar.style.width='0%';progBar.style.background='#c9a96e';}
      if(progLbl){progLbl.textContent='Uploading… 0%';}
      _popUploading=true;_popUploadedUrl=null;_popUploadError=null;
      uploadPhotoXHR(f, progBar, progLbl)
        .then(function(url){
          _popUploadedUrl=url;
          _popUploading=false;
          _popUploadError=null;
        })
        .catch(function(err){
          _popUploading=false;
          _popUploadError=err.message;
          if(progBar){progBar.style.width='100%';progBar.style.background='#e53935';}
          if(progLbl){progLbl.textContent='⚠ Upload failed — please retry';}
        });
    };
    if(rem){rem.onclick=function(){
      if(file)file.value='';
      _popUploading=false;_popUploadedUrl=null;_popUploadError=null;
      zone.style.display='block';
      if(prev)prev.style.display='none';
      if(progWrap)progWrap.style.display='none';
      if(progBar){progBar.style.width='0%';}
    };}
  }

  function collectCustomProps(c,pfx,wrap){
    var props={},valid=true;
    if(!c||c.noCustom)return props;
    if(c.upload){
      var file=wrap.querySelector('#'+pfx+'-file');
      var ue=wrap.querySelector('#'+pfx+'-uerr');
      var prev=wrap.querySelector('#'+pfx+'-prev');
      if(!prev||prev.style.display==='none'||!file||!file.files||!file.files.length){
        if(ue){ue.style.display='block';ue.scrollIntoView({behavior:'smooth',block:'nearest'});}
        valid=false;
      } else {
        if(ue)ue.style.display='none';
        // URL will be attached after upload completes in ATC handler
      }
    }
    if(c.front){var ft=wrap.querySelector('#'+pfx+'-ftxt');if(ft&&ft.value.trim())props['Front Text Engraving']=ft.value.trim();}
    if(c.back){var bt=wrap.querySelector('#'+pfx+'-btxt');if(bt&&bt.value.trim())props['Back Text Engraving']=bt.value.trim();}
    if(c.forher){var fhr=wrap.querySelector('#'+pfx+'-fhrtxt'),fhre=wrap.querySelector('#'+pfx+'-fhrerr');if(!fhr||!fhr.value.trim()){if(fhre){fhre.style.display='block';fhre.scrollIntoView({behavior:'smooth',block:'nearest'});}valid=false;}else{props['Front Text Engraving - For Her']=fhr.value.trim();if(fhre)fhre.style.display='none';}}
    if(c.forhim){var fhm=wrap.querySelector('#'+pfx+'-fhmtxt'),fhme=wrap.querySelector('#'+pfx+'-fhmerr');if(!fhm||!fhm.value.trim()){if(fhme){fhme.style.display='block';fhme.scrollIntoView({behavior:'smooth',block:'nearest'});}valid=false;}else{props['Back Text Engraving - For Him']=fhm.value.trim();if(fhme)fhme.style.display='none';}}
    if(c.leftright){
      var lt=wrap.querySelector('#'+pfx+'-ltxt'),le=wrap.querySelector('#'+pfx+'-lerr'),rt=wrap.querySelector('#'+pfx+'-rtxt'),re=wrap.querySelector('#'+pfx+'-rerr');
      if(!lt||!lt.value.trim()){if(le){le.style.display='block';le.scrollIntoView({behavior:'smooth',block:'nearest'});}valid=false;}else{props['Left Heart Engraving']=lt.value.trim();if(le)le.style.display='none';}
      if(valid){if(!rt||!rt.value.trim()){if(re){re.style.display='block';re.scrollIntoView({behavior:'smooth',block:'nearest'});}valid=false;}else{props['Right Heart Engraving']=rt.value.trim();if(re)re.style.display='none';}}
    }
    if(c.morse){var mt=wrap.querySelector('#'+pfx+'-mtxt'),me=wrap.querySelector('#'+pfx+'-merr');if(!mt||!mt.value.trim()){if(me){me.style.display='block';me.scrollIntoView({behavior:'smooth',block:'nearest'});}valid=false;}else{props['Morse Code Customization']=mt.value.trim();if(me)me.style.display='none';}}
    if(c.birthstonemix){
      var bsmCount=bsmPopCount();
      var bsmFilled=Object.keys(_popBsmSelections).length;
      var bsmErr=wrap.querySelector('#'+pfx+'-bsm-err');
      if(bsmFilled<bsmCount){
        if(bsmErr){bsmErr.style.display='block';bsmErr.scrollIntoView({behavior:'smooth',block:'nearest'});}
        valid=false;
      } else {
        if(bsmErr)bsmErr.style.display='none';
        for(var bi=1;bi<=bsmCount;bi++){if(_popBsmSelections[bi])props['Birthstone '+bi]=_popBsmSelections[bi];}
      }
    }
    return valid?props:null;
  }

  function handleFPBtn(btn){var handle=btn.dataset.productHandle;if(!handle)return;showFPPopup(handle,btn.dataset.productId||0,btn.dataset.productTags||'',0);}

  function hookDawn(){
    if(window.subscribe){
      try{
        window.subscribe('cart:open',function(){setTimeout(openDrawer,0);});
        window.subscribe('cart:refresh',function(){renderCart();});
        window.subscribe('cart-update',function(){if(el('dw-cart-drawer')&&el('dw-cart-drawer').classList.contains('dw-open'))renderCart();});
      }catch(e){}
    }
    var obs=new MutationObserver(function(muts){muts.forEach(function(m){m.addedNodes.forEach(function(node){if(node.nodeType!==1)return;if(node.tagName==='CART-NOTIFICATION'||node.classList&&node.classList.contains('cart-notification')){node.style.display='none';node.setAttribute('hidden','');openDrawer();}});});});
    obs.observe(document.body,{childList:true,subtree:false});
    var cn=document.querySelector('cart-notification');
    if(cn){new MutationObserver(function(){if(!cn.hidden&&cn.getAttribute('aria-hidden')!=='true'){cn.style.display='none';cn.setAttribute('hidden','');openDrawer();}}).observe(cn,{attributes:true,attributeFilter:['class','hidden']});}
    document.querySelectorAll('#cart-icon-bubble,[href="/cart"].header__icon--cart,a[href="/cart"]').forEach(function(e){e.addEventListener('click',function(ev){ev.preventDefault();openDrawer();});});
  }

  function injectPopupStyles(){
    if(document.getElementById('dw-popup-styles'))return;
    var s=document.createElement('style');s.id='dw-popup-styles';
    s.textContent=[
      '.dw-popup-field{margin-bottom:14px}',
      '.dw-popup-label{font-family:var(--dw-font-body,sans-serif);font-size:10px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#1a1a1a;display:block;margin-bottom:6px}',
      '.dw-popup-select{width:100%;border:1px solid #ddd;padding:9px 12px;font-size:13px;font-family:var(--dw-font-body,sans-serif);color:#1a1a1a;background:#fff;outline:none;appearance:none;-webkit-appearance:none;cursor:pointer}',
      '.dw-popup-select:focus{border-color:#c9a96e}',
      '.dw-popup-qty-row{display:flex;align-items:center;justify-content:space-between}',
      '.dw-popup-qty{display:flex;align-items:center;border:1px solid #ddd}',
      '.dw-popup-qty-btn{width:32px;height:32px;background:#fff;border:none;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .15s}',
      '.dw-popup-qty-btn:hover{background:#f9f5f0}',
      '.dw-popup-qty-val{width:36px;height:32px;display:flex;align-items:center;justify-content:center;font-size:13px;font-family:var(--dw-font-body,sans-serif);border-left:1px solid #ddd;border-right:1px solid #ddd}',
      '.dw-fp-popup__img{transition:opacity .15s ease}',
      '.dw-fp-popup__price{font-size:15px;font-weight:700;color:#c9a96e;margin-top:4px;font-family:var(--dw-font-body,sans-serif)}',
      '.dw-popup-ins{border:1px solid #ece8e1;padding:12px;margin-top:14px;background:#fafaf8}',
      '.dw-popup-ins__row{display:flex;align-items:flex-start;gap:10px}',
      '.dw-popup-ins__check{width:20px;height:20px;min-width:20px;border:2px solid #ccc;border-radius:2px;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all .15s;margin-top:2px}',
      '.dw-popup-ins__check--on{background:#c9a96e;border-color:#c9a96e}',
      '.dw-popup-ins__check svg{width:13px;height:13px;fill:#fff;display:block}',
      '.dw-popup-ins__check:not(.dw-popup-ins__check--on) svg{display:none}',
      '.dw-popup-ins__body{flex:1;min-width:0}',
      '.dw-popup-ins__title{font-size:12px;font-weight:600;color:#1a1a1a;font-family:var(--dw-font-body,sans-serif);display:flex;align-items:center;gap:6px;flex-wrap:wrap}',
      '.dw-popup-ins__price{color:#c9a96e;font-weight:700}',
      '.dw-popup-ins__desc{font-size:11px;color:#888;margin-top:3px;font-family:var(--dw-font-body,sans-serif);line-height:1.4}',
      '.dw-bsm-hint{font-family:\'Helvetica Neue\',sans-serif;font-size:11px;color:#888;margin-bottom:10px}',
      '.dw-bsm-slots{display:flex;flex-direction:column;gap:8px}',
      '.dw-bsm-slot{border:1px solid #ece8e1;padding:9px 11px;cursor:pointer;transition:border-color .15s;background:#fff}',
      '.dw-bsm-slot.dw-bsm-open{border-color:#c9a96e;background:#fff}',
      '.dw-bsm-slot-head{display:flex;align-items:center;gap:10px}',
      '.dw-bsm-num{width:18px;height:18px;border-radius:50%;background:#f9f5f0;color:#c9a96e;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-family:\'Helvetica Neue\',sans-serif}',
      '.dw-bsm-swatch{width:18px;height:18px;border-radius:50%!important;flex-shrink:0;border:1px solid rgba(0,0,0,.15);box-sizing:border-box;display:block!important}',
      '.dw-bsm-name{font-family:\'Helvetica Neue\',sans-serif;font-size:12px;flex:1;color:#1a1a1a}',
      '.dw-bsm-name.dw-bsm-placeholder{color:#bbb;font-style:italic}',
      '.dw-bsm-chevron{font-size:9px;color:#bbb;flex-shrink:0}',
      '.dw-bsm-picker{display:none;margin-top:10px;padding-top:10px;border-top:1px dashed #ece8e1;grid-template-columns:repeat(6,1fr);gap:8px;background:#fff}',
      '.dw-bsm-slot.dw-bsm-open .dw-bsm-picker{display:grid}',
      '.dw-bsm-month{text-align:center;cursor:pointer}',
      '.dw-bsm-dot{width:22px!important;height:22px!important;border-radius:50%!important;margin:0 auto 3px!important;border:2px solid transparent!important;box-sizing:border-box!important;display:block!important}',
      '.dw-bsm-month.dw-bsm-selected .dw-bsm-dot{border-color:#1a1a1a!important}',
      '.dw-bsm-month .m{font-size:8px;color:#888;text-transform:uppercase;letter-spacing:.02em;font-family:\'Helvetica Neue\',sans-serif}'
    ].join('');
    document.head.appendChild(s);
  }

  function init(){
    injectPopupStyles();
    var cb=el('dw-cart-close');if(cb)cb.addEventListener('click',closeDrawer);
    var co=el('dw-cart-overlay');if(co)co.addEventListener('click',closeDrawer);
    var cc=el('dw-cart-continue');if(cc)cc.addEventListener('click',closeDrawer);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closePopup();}});
    document.addEventListener('click',function(e){var btn=e.target.closest('[data-dw-fp-btn]');if(btn)handleFPBtn(btn);});
    var dToggle=el('dw-cart-discount-toggle');
    if(dToggle)dToggle.addEventListener('click',function(){var f=el('dw-cart-discount-form');if(f)f.style.display='flex';dToggle.style.display='none';var inp=el('dw-cart-discount-input');if(inp)inp.focus();});
    var dApply=el('dw-cart-discount-apply');
    if(dApply)dApply.addEventListener('click',function(){var inp=el('dw-cart-discount-input');if(inp&&inp.value.trim())applyDiscount(inp.value.trim());});
    var dInput=el('dw-cart-discount-input');
    if(dInput)dInput.addEventListener('keydown',function(e){if(e.key==='Enter'&&dInput.value.trim())applyDiscount(dInput.value.trim());});
    var dRemove=el('dw-cart-discount-remove');
    if(dRemove)dRemove.addEventListener('click',removeDiscount);
    purgeOrphanInsurance().then(function(cart){
      if(!cart){updateBadge(0);return;}
      var realCount=cart.items.filter(function(i){return !DW_INSURANCE_PIDS.includes(String(i.product_id));}).reduce(function(s,i){return s+i.quantity;},0);
      updateBadge(realCount);
    }).catch(function(){});
    var d=el('dw-cart-drawer');if(d){var w=d.closest('.shopify-section');if(w){w.style.position='static';w.style.zIndex='auto';w.style.isolation='auto';w.style.contain='none';}}
    hookDawn();
  }

  var _real = {open:openDrawer, close:closeDrawer, refresh:renderCart};
  if (window.DWCart && typeof window.DWCart._drainQueue === 'function') {
    window.DWCart._drainQueue(_real);
  }
  window.DWCart = _real;

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
/* DW-END */
